import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

interface User {
  name: string | undefined;
  email: string;
  from: string;
}

interface LocalStorageEvents {
  userId: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class UserBehaviorService {
  private user = new BehaviorSubject<User>({
    name: '',
    email: '',
    from: ''
  });
  selectedUser = this.user.asObservable();

  private localStorageEvents = new BehaviorSubject<LocalStorageEvents>({
    userId: false
  });

  localStorageEvents$ = this.localStorageEvents.asObservable();

  setUser(user: User) {
    const previousValue = this.user.getValue();

    if (previousValue.name === user.name && previousValue.email === user.email) {
      return;
    }

    this.user.next(user);
  }

  emitUserIdEvent(isEventEmitted: boolean): void {
    const previousValue = this.localStorageEvents.getValue();

    this.localStorageEvents.next({
      ...previousValue,
      userId: isEventEmitted
    });
  }

  resetLocalStorageEvent(): void {
    this.localStorageEvents.next({
      userId: false
    });
  }

  async fromBehavior(): Promise<User | null> {
    const user = this.user.getValue();

    if (!user.email) {
      return null;
    }

    return user;
  }

  fromBehaviorObservable(): Observable<User | null> {
    return this.selectedUser.pipe(
      map((user) => (user.email ? user : null))
    );
  }
}
